import domReady from '@wordpress/dom-ready';
import MicroModal from 'micromodal';
import manifest from './../manifest.json';

domReady(async () => {
	const { componentJsClass } = manifest;

	const body = document.querySelector('body');
	const modalSelector = `.${componentJsClass}`;
	const modalElements = document.querySelectorAll(modalSelector);

	if (!modalElements.length) {
		return;
	}

	// Append all modals at the bottom of body.
	[...modalElements].forEach((element) => {
		body.append(element);
	});

	MicroModal.init({
		awaitOpenAnimation: true,
		awaitCloseAnimation: true,
		disableScroll: true,
		onShow: (modal) => {
			const video = modal.querySelector('video');

			if (video) {
				video.play();
			}
		},
		onClose: (modal) => {
			// Pause video elements
			const video = modal.querySelector('video');

			if (video) {
				video.pause();
			}

			// Reload iframe embeds
			const iframe = modal.querySelector('iframe');

			if (iframe) {
				iframe.src = iframe.src;
			}
		},
	});
});
